import { actions } from './actions'

const initialState = {
  data: [],
}

export default function subtopicsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_SUBTOPICS_RESULT:
      return { ...state, data: action.payload.data }
    default:
      return state
  }
}
